module.exports = __webpack_public_path__ + "static/media/90-points.ae0c6290.png";